export default "__VITE_ASSET__46eac8ff__"